/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptDayOptions } from '../models/V3StackAdaptDayOptions';
import { HttpFile } from '../http/http';

/**
* Weekday parting for a StackAdapt campaign flight
*/
export class V3StackAdaptWeekdayParting {
    /**
    * Whether weekday parting is enabled
    */
    'enabled'?: boolean;
    'dayOptions'?: V3StackAdaptDayOptions;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dayOptions",
            "baseName": "dayOptions",
            "type": "V3StackAdaptDayOptions",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptWeekdayParting.attributeTypeMap;
    }

    public constructor() {
    }
}

